/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const GRAPHQL_ENDPOINT = String(process.env.REACT_APP_GRAPHQL_ENDPOINT);

export const MOCK_CUSTOMER_ID = process.env.REACT_APP_MOCK_CUSTOMER_ID ?? "";

export const CODE_VERSION = String(process.env.CODE_VERSION);

export const APP_ENV = String(process.env.REACT_APP_ENV ?? "unknown") as
  | "development"
  | "production-uk"
  | "production-us"
  | "production"
  | "staging"
  | "unknown";

export const NODE_ENV = String(process.env.NODE_ENV ?? "unknown") as
  | "development"
  | "production"
  | "test"
  | "unknown";
export const isNotLocalServer = NODE_ENV === "production";

export const isProdEnv = APP_ENV.includes("production");
